import { styled } from '@mui/system';

const RouteErrorBoundaryWrapper = styled('div')(({ theme }) => ({
  borderColor: theme.palette.primary.main,
}));

export default RouteErrorBoundaryWrapper;
export {};
